/**
 * Push notification system.
 */
import 'firebase/messaging'
import firebaseApp from './app'


enum NotificationPermission {
    DEFAULT = 'default',
    DENIED = 'denied',
    GRANTED = 'granted'
}


const messaging = firebaseApp.messaging()
messaging.usePublicVapidKey('BDdI4o2x8z86rmNsc9NxR3HWjXSzHZQ0zd4O9cKlCTtmdeJEid78s5XPMIMqZCX1Rj9SmM3piK6WaMqcmBGl_rk')

/**
 * Callback fired if Instance ID token is updated.
 */
messaging.onTokenRefresh(async() => {
    const refreshedToken = await messaging.getToken()
    console.log('Token refreshed.', refreshedToken)
})


function getToken(): Promise<string> {
    return messaging.getToken()
}


function getPermissionState(): NotificationPermission {
    return Notification.permission as NotificationPermission
}


export { getToken, getPermissionState, NotificationPermission }
